import { APP_VERSION as _APP_VERSION, APP_BUILD as _APP_BUILD, EMAILS } from 'config/constants';
import Text from 'common/ui/Text';
import { Stack } from '../Layout';
import { env } from 'config/env';
import { Barcode } from 'common/Account/Barcode';
import { Colors } from 'styles';
import { css } from 'styled-components';

const APP_VERSION = env.NODE_ENV === 'test' ? 'test' : _APP_VERSION;
const APP_BUILD = env.NODE_ENV === 'test' ? '??????' : _APP_BUILD;

export const SironaWorkspaceInfo = (): React.ReactElement => {
  return (
    <Stack
      space="large"
      alignX="center"
      alignY="center"
      vertical
      css={`
        text-align: center;
      `}
    >
      <img
        alt="Sirona Medical RadOS"
        src="/logos/logoMain.png"
        css={`
          max-height: 90px;
          max-width: 337.5px;
        `}
      />

      <Text variant="body1">RadOS Workspace</Text>

      <div
        css={`
          font-weight: 500;
        `}
      >
        {!!APP_VERSION && (
          <div>
            <Text variant="body1">Version: {APP_VERSION}</Text>
          </div>
        )}
        {!!APP_BUILD && (
          <div>
            <Text variant="body1">Build: {APP_BUILD}</Text>
          </div>
        )}
      </div>

      <div
        css={`
          font-weight: 500;
        `}
      >
        <div>
          <Text variant="body1">
            General support: use in-product chat or email{' '}
            <a
              css={css`
                color: ${Colors.blue5};
              `}
              href={`mailto:${EMAILS.SUPPORT}`}
            >
              {EMAILS.SUPPORT}
            </a>
          </Text>
        </div>

        <div>
          <Text variant="body1">
            IT support:{' '}
            <a
              css={css`
                color: ${Colors.blue5};
              `}
              href={`mailto:${EMAILS.ITSUPPORT}`}
            >
              {EMAILS.ITSUPPORT}
            </a>
          </Text>
        </div>
      </div>

      <div>
        <div>
          <Text variant="body2">171 2nd St Suite 600</Text>
        </div>
        <div>
          <Text variant="body2">San Francisco, CA 94105</Text>
        </div>
      </div>
      <div>
        <Barcode />
      </div>
      <Text variant="small">
        Copyright &copy; 2018-{new Date().getFullYear()} Sirona Medical, Inc.
      </Text>
    </Stack>
  );
};
